import React, { useState, useRef } from "react";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Button from "react-bootstrap/Button";
import { Form } from "react-bootstrap";
import PartSpecifications from "../PartSpecifications";
import PrintSpecification from "../PrintSpecification/PrintSpecification";
import "./inputRequirement.scss";
import STLViewer from "../../STLViewer";
import Loader from "../../utils/loader/Loader";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store/store";
import ModalPopupComponent from "../ModalPopup/ModalPopup";
import { useNavigate } from "react-router-dom";
import loaderIcon from "../../assets/images/loader.svg";
//import { analyzePart, sendMeshTopic } from "../../services/part/partService";
import {
  analyzePart,
  sendMeshTopic,
  generateMeshEstimate,
  generateCostEstimate
} from "../../services/part/partService";

import GenerateQuotePage
from "../GenerateQuote/GenerateQuote";

import { showErrorToast, showSuccessToast } from "../../utils/toast/notificationPopup";

import { MathUtils } from "three";
import { getMesh } from "../SceneViewer";

const InputRequirement = (props) => {
  const [showLoader, setShowLoader] = useState(false);
  const navigate = useNavigate();
  const [partPreviewImage, setPartPreviewImage] = useState(props?.partIcon);

  const [specStep, setSpecStep] = useState(0);
  const [completedSteps, setCompletedSteps] = useState({
    part: false,
    print: false
  });
  const [showQuoteResultModal, setShowQuoteResultModal] =
  useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showQuoteNameModal, setShowQuoteNameModal] = useState(false);
  const [quoteName, setQuoteName] = useState("");
  const [isModifying, setIsModifying] = useState(props.isEdit || false);

  const [costData, setCostData] = useState(null);

  const checkHeight = { height: true };
  const checkHole = { hole: true };
  const checkTunnel = { tunnel: true };
  const checkLayer = { layer: { slab: 0.1 } };
  const layerOverhang = { layer_overhang: { slab: 0.1 } };
  const thinWall = { thin_wall: [1, 3, 5] };
  const cutSim = { cutsim: { dia: [6, 10, 20] } };

  const userData = useSelector((state: RootState) => state.login);
  const { userName } = userData;

  const handleLoader = () => {
    setShowLoader(false);
  };

  const handleAnalysis = async (data = {}) => {
    try {

      const partSpecificationData = { ...data };
      const partSpecificationData2 = {
        ...partSpecificationData,
        ...checkHeight,
        ...checkHole,
        ...checkTunnel,
        ...checkLayer
      };
      const partSpecificationData3 = {
        ...partSpecificationData2,
        ...layerOverhang,
        ...thinWall,
        ...cutSim
      };

      console.log("Final Payload:", partSpecificationData3);

      setShowLoader(true);

      await sendMeshTopic(props.partId, props.modelName);

      const response = await analyzePart(
        props.partId,
        props.modelName,
        JSON.stringify(partSpecificationData3)
      );


      if (response?.success) {
        showSuccessToast("Analyze is InProgress");
      } else {
        throw new Error("Analysis failed");
      }
    } catch (error) {
      showErrorToast("Error starting analysis");
    } finally {
      setShowLoader(false);
    }
  };

  const handleNext = () => {
    if (specStep === 0) {
      setCompletedSteps(prev => ({ ...prev, part: true }));
      setSpecStep(1);
    } else if (specStep === 1) {
      setCompletedSteps(prev => ({ ...prev, print: true }));

      /*if (isModifying) {
        setShowQuoteNameModal(true);
      } else {
        setShowModal(true);
      }*/

      handleQuoteNameContinue();
    }
  };

  const handleEditInputRequirement = () => {
    setShowModal(false);
    setIsModifying(true);
    setSpecStep(0);
  };

  const handleQuoteNameContinue = async () => {

    try {
  
      setShowLoader(true);

      const mesh = getMesh();
      const transform = {
        rotate: {
          x:
            MathUtils.radToDeg(
              mesh.rotation.x
            ),
          y:
            MathUtils.radToDeg(
              mesh.rotation.y
            ),
          z:
            MathUtils.radToDeg(
              mesh.rotation.z
            )
        },
        translate: {
          x: mesh.position.x,
          y: mesh.position.y,
          z: mesh.position.z
        },
        scale: {
          x: mesh.scale.x,
          y: mesh.scale.y,
          z: mesh.scale.z
        }
      }

      console.log(
        "SENDING TRANSFORM TO BACKEND:",
        transform
      );

      const costResponse =
        await generateCostEstimate(
          props.partId,
          transform
        );

      setCostData(
        costResponse.costBreakdown
      );

      console.log("NAVIGATING NOW");

      //navigate(`/generate-quote/${props.partId}`);

      setShowQuoteResultModal(true);      
  
    } catch (error) {
  
      console.error(
        "QUOTE GENERATION ERROR:",
        error
      );
  
      showErrorToast(
        "Error generating quote"
      );
  
    } finally {
  
      setShowLoader(false);
    }
  };

  return (
    <div>
      <Loader visible={showLoader} />  
      <section className="plates page review-page">
      <div className="calculate-cost-global">
            <Button
              className={`calculate-top-btn`}
              variant="primary"
              onClick={handleQuoteNameContinue}
              disabled={showQuoteResultModal}
            >
              Calculate Cost
            </Button>
      </div>
      <div className="quote-page-container">
          <section className="plate view">
          <div className="right-view prevew-controls w-100">
            <div className="calculate-cost-top-right">
            </div>
            <STLViewer
              showPartDetails={false}
              partName={props.partName}
              modelName={props.modelName}
              partId={props.partId}
              sourceType={"source"}
              isLoaded={handleLoader}
            />
          </div>
          <ModalPopupComponent
          show={showQuoteResultModal}
          onHide={() => setShowQuoteResultModal(false)}
          title="Generated Quote"    
          footerButtons={[
            {
              label: "Close",
              variant: "secondary",
              onClick: () =>
                setShowQuoteResultModal(false)
            }
          ]}
        >
          <div        
            style={{
              width: '90vw',
              maxWidth: '1400px',
              minHeight: '80vh',
              overflowY: 'auto',
              padding: '20px'
            }}
          >
            <GenerateQuotePage
              partId={props.partId}
              previewImage={partPreviewImage}
              costData={costData}
            />
          </div>
        </ModalPopupComponent>  
        </section>
      </div>
      </section>   
    </div>
  );
};

export default InputRequirement;